<!-- Modal Overlay -->
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Import License Plates</h2>
      <button class="close-btn" (click)="onClose()">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M9 3L3 9M3 3L9 9"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Description -->
      <p *ngIf="!selectedFile()" class="description">
        Upload a spreadsheet with all license plate numbers of the fleet vehicles.
      </p>

      <!-- File Upload Area (Initial State) -->
      <div *ngIf="!selectedFile()" class="upload-section">
        <!-- Upload Dropzone -->
        <app-file-upload-dropzone
          accept=".csv,.xlsx,.xls"
          title="Drag your file here or"
          browseLinkText="click to upload"
          subtitle="CSV or XLSX (max 10MB)"
          (fileSelected)="handleFile($event)"
        ></app-file-upload-dropzone>

        <!-- File Requirements -->
        <div class="file-requirements">
          <h4 class="requirements-title">File Requirements:</h4>
          <ul class="requirements-list">
            <li>First row must contain column headers</li>
            <li>Required columns: License Plate</li>
            <li>
              Optional columns: State (2-letter US code, e.g. CA). Or add it to the plate after a
              hyphen, e.g. 1X25FG4-CA. If left blank, it is filled from the fleet's location when
              all its locations are in one state.
            </li>
          </ul>
          <button class="template-link" (click)="onDownloadTemplate()">
            Download an example <span class="csv-template">.csv template</span>
          </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="error()" class="error-message">
          {{ error() }}
        </div>
      </div>

      <!-- File Selected State -->
      <div *ngIf="selectedFile()" class="file-selected-section">
        <!-- Instructional Text -->
        <p class="instruction-text">Please review the file below and click Import</p>

        <!-- Selected File Display -->
        <div class="selected-file-display">
          <div class="file-info">
            <div class="file-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M3.33 2L13.33 2L16.67 5.33V18L3.33 18L3.33 2Z"
                  stroke="#079271"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 2L10 5.33L13.33 5.33"
                  stroke="#079271"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 14L12 14"
                  stroke="#079271"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="file-name">{{ selectedFile()?.name }}</span>
          </div>
          <div class="file-actions">
            <button class="view-file-btn" (click)="onViewFile()">View file</button>
            <button class="remove-file-btn" (click)="onRemoveFile()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M15 5L5 15M5 5L15 15"
                  stroke="#101223"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="error()" class="error-message">
          {{ error() }}
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="cancel-btn" (click)="onClose()">Cancel</button>
      <button
        class="import-btn"
        [class.disabled]="!isValidFile() || isUploading()"
        [disabled]="!isValidFile() || isUploading()"
        (click)="onImport()"
      >
        <span *ngIf="isUploading()">Importing...</span>
        <span *ngIf="!isUploading()">Import</span>
      </button>
    </div>
  </div>
</div>
